import React from "react";
import { useTranslation } from "react-i18next";
import { ServiceTypeSelectorOption } from "../../../../../../src/types/order";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { checkIfOrderCanBeStarted } from "../../../../../util";

// Props for BookingSummaryNote
type BookingSummaryNoteProps = {
  serviceType: ServiceTypeSelectorOption;
};

function BookingSummaryNote({ serviceType }: BookingSummaryNoteProps) {
  const { t } = useTranslation();
  const isApartment = serviceType === ServiceTypeSelectorOption.APARTMENT;
  const isSUP = serviceType === ServiceTypeSelectorOption.SUP;
  const isVenue = serviceType === ServiceTypeSelectorOption.VENUE;
  const isKeys = serviceType === ServiceTypeSelectorOption.KEYS;

  const { selectedBooking } = useSelector(
    (state: RootState) => state.booking
  );

  const isRentalFinished = selectedBooking?.items?.[0]?.rental.finishedAtDate
  const gracePeriodMinutes = useSelector(
    (state: RootState) => state.tenantConfig.config.gracePeriodMinutes

  );

  // Early return if SUP and note should not be shown
  if (isSUP && isRentalFinished) {
    return null;
  }

  // Determine the content for the note
  let noteContent: string;
  if (isSUP) {
    noteContent = checkIfOrderCanBeStarted(selectedBooking!, gracePeriodMinutes)
      ? t("orders.ticket_overview.generic_note.sup_content")
      : t("orders.ticket_overview.generic_note.content");
  } else if (isApartment) {
    noteContent = t("orders.ticket_overview.apartment_overview_note.content");
  } else if(isVenue){
    noteContent = t("book_location.venue_reservation_overview.apartment_overview_note.content");
  }
  else if(isKeys){
    noteContent = t("orders.ticket_overview.generic_note.keys_content");
  }

   else {
    noteContent = t("orders.ticket_overview.generic_note.content");
  }

  return (
    <div className="bg-[#EDF0F5] rounded p-2 text-sm mb-2 w-full">
      <span className="font-bold">
      {t("orders.ticket_overview.apartment_overview_note.nb")}
      </span>
      {noteContent} 
      <a
      href="/hints/page/HelpAccordionList"
      className="ml-1 underline"
      target="_blank"
      rel="noopener noreferrer"
      >
      {t("report_issue.help.report_issue")}
      </a>
    </div>
  );
}

export default BookingSummaryNote;

